// components
import { DesktopHero } from './desktop'
import { MobileHero } from './mobile'

// styles
import classes from './styles.module.scss'

// types
import type { AuthHeroQuoteProps } from './quote'
import type { StaticImageData } from 'next/image'
import type { FC } from 'react'

type AuthHeroProps = {
  backgroundImage: StaticImageData
  quote?: AuthHeroQuoteProps
  mobileAction?: {
    label: string
    action: () => void
  }
}

export const Hero: FC<AuthHeroProps> = ({ mobileAction, ...props }) => (
  <>
    <div className={classes.container}>
      <DesktopHero {...props} />
    </div>

    <MobileHero {...props} action={mobileAction} />
  </>
)
